module.exports = __webpack_public_path__ + "static/header-bg-buildings-cf69694b586a9a7e3e19b52c3b378f44.svg";